export default __webpack_public_path__ + "static/media/complementary--trucks-go-straight--g1.76cd0c33.png";